const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/858d9195860a30259d8e81082899b187.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="font-['Inter'] font-extralight text-white text-sm tracking-[0.2em] uppercase">
                CANDOR d.o.o.
              </h1>
              <div className="space-y-2">
                <h2 className="font-['Inter'] font-bold text-white text-6xl lg:text-7xl leading-tight">
                  Modern iOS
                </h2>
                <h2 className="font-['Inter'] font-bold text-white text-6xl lg:text-7xl leading-tight pl-10">
                  Applications
                </h2>
                <h2 className="font-['Inter'] font-bold text-white text-6xl lg:text-7xl leading-tight pl-20 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                  Redefined
                </h2>
              </div>
            </div>
            <p className="text-white/90 text-lg leading-relaxed max-w-lg font-light">
              A team of experts developing modern applications for the iOS platform, designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-blue-500/20 blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=modern%20iPhone%20mockup%20displaying%20sleek%20VPN%20application%20interface%20with%20gradient%20purple%20and%20blue%20colors%2C%20floating%20at%20slight%20angle%2C%20professional%20product%20photography%2C%20clean%20minimalist%20UI%20design%2C%20security%20shield%20icons%2C%20premium%20mobile%20app%20showcase%2C%20realistic%20device%20render%2C%20contemporary%20tech%20aesthetic%2C%20high%20quality%203D%20visualization&width=600&height=800&seq=hero-phone-001&orientation=portrait"
                alt="iOS Application"
                className="relative w-80 h-auto transform rotate-6 hover:rotate-0 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <div className="w-px h-16 bg-white/40"></div>
          <div className="w-2 h-2 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
